module.exports = __webpack_public_path__ + "img/tip_warning_es.035ad04f.png";